import { useConnectionStatusStore } from '../stores/connectionStatusStore'

export type AggregatedStatus = 'open' | 'connecting' | 'error' | 'idle'

export function useConnectionStatus(): { status: AggregatedStatus; reconnectCount: number; activeCount: number } {
  const connections = useConnectionStatusStore((s) => s.connections)
  const values = Object.values(connections)
  const activeCount = values.length

  if (activeCount === 0) return { status: 'idle', reconnectCount: 0, activeCount: 0 }

  const reconnectCount = values.reduce((sum, c) => sum + c.reconnectCount, 0)
  const statuses = values.map((c) => c.status)

  if (statuses.some((s) => s === 'error' || s === 'closed')) {
    return { status: 'error', reconnectCount, activeCount }
  }
  if (statuses.some((s) => s === 'connecting')) {
    return { status: 'connecting', reconnectCount, activeCount }
  }
  return { status: 'open', reconnectCount, activeCount }
}
